export default __webpack_public_path__ + "static/title-mb-020e503212af275b0616bca1e9679247.png";